import { Dialog } from '@design-system/dialog';
import { Typography } from '@design-system/typography';
import {
  getLocalStorageData,
  removeLocalStorageData,
} from '@phx-husky/local-storage';
import { ScreenRecognitionContext } from '@phx-husky/screen-recognition';
import { navigate } from 'gatsby';
import React, { FC, useContext } from 'react';

import { ExternalLinkDialogContext } from '~/context/ExternalLinkDialogContext';
import { modalExternalMapper } from '~/mappers/modalExternal';
import { gtmService } from '~/services/gtm';
import { GTM_LOCALSTORAGE_DATA } from '~/utils/constants';

export const ExternalLinkDialog: FC = () => {
  const { close, isVisible, redirectUrl, modalExternal, isModalExternal } =
    useContext(ExternalLinkDialogContext);
  const { isMobile } = useContext(ScreenRecognitionContext);
  const lastRetailer = getLocalStorageData(
    GTM_LOCALSTORAGE_DATA.lastRetailerTitle
  );

  if (!isModalExternal || !modalExternal) {
    return null;
  }

  const { titleContent, data, ...otherProps } =
    modalExternalMapper(modalExternal);

  return (
    <Dialog
      {...otherProps}
      // @ts-ignore
      isShowing={isVisible}
      close={close}
      closeModal={close}
      titleContent={
        titleContent && (
          <Typography
            tag="h3"
            weight="bold"
            variant="headline"
            size="m"
            content={titleContent.toString()}
          />
        )
      }
      data={
        data && (
          <Typography
            tag="p"
            variant="body"
            size="m"
            content={data.toString()}
          />
        )
      }
      onPrimaryButtonClick={() => {
        if (lastRetailer) {
          gtmService.emitRetailerLinkConfirmation(lastRetailer, redirectUrl);
          removeLocalStorageData(GTM_LOCALSTORAGE_DATA.lastRetailerTitle);
        }
        navigate(redirectUrl);
      }}
      containerElement={
        isMobile
          ? (document.querySelector('.header-portal') as HTMLElement)
          : document.body
      }
    />
  );
};

export default ExternalLinkDialog;
